import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import LocalSEO from './pages/LocalSEO';
import GEO from './pages/GEO';
import Industries from './pages/Industries';
import Blog from './pages/Blog';
import Contact from './pages/Contact';

// New Service Articles
import TechnicalSEOArticle from './pages/Services/TechnicalSEOArticle';
import ContentMarketingArticle from './pages/Services/ContentMarketingArticle';
import AiCitationArticle from './pages/Services/AiCitationArticle';
import ReputationManagementArticle from './pages/Services/ReputationManagementArticle';
import EnterpriseSEOArticle from './pages/Services/EnterpriseSEOArticle';

function App() {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/nyc-local-seo" element={<LocalSEO />} />
          <Route path="/geo-ai-optimization" element={<GEO />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Service Article Routes */}
          <Route path="/services/technical-seo" element={<TechnicalSEOArticle />} />
          <Route path="/services/content-marketing" element={<ContentMarketingArticle />} />
          <Route path="/services/ai-citation" element={<AiCitationArticle />} />
          <Route path="/services/reputation-management" element={<ReputationManagementArticle />} />
          <Route path="/services/enterprise-seo" element={<EnterpriseSEOArticle />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
}

export default App;